import styled from 'styled-components';

const ModalTitleContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
`;

export default ModalTitleContainer;
